import { render, staticRenderFns } from "./DposListTable.vue?vue&type=template&id=716d2af8&"
import script from "./DposListTable.vue?vue&type=script&lang=js&"
export * from "./DposListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports